import { useEffect, type RefObject } from 'react';
import { isTypingTarget } from '../../components/CommandPalette/isTypingTarget';

/**
 * "/" focuses the search box (design a1 hint "/ to focus"), unless the user types in a field. On
 * this page "/" does not open the command palette: the palette skips a prevented key.
 */
export function useSlashFocus(inputRef: RefObject<HTMLInputElement | null>): void {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key !== '/' || event.metaKey || event.ctrlKey || event.altKey || isTypingTarget(event.target)) {
        return;
      }
      event.preventDefault();
      inputRef.current?.focus();
    };
    // The capture phase runs before the palette key of the app shell, whatever the mount order.
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }, [inputRef]);
}
